var map = {
	"./animal-crossing.png": "fd13",
	"./arms.png": "1210",
	"./banjo-kazooie.png": "0593",
	"./bayonetta.png": "6de5",
	"./castlevania.png": "c1b6",
	"./default.png": "619f",
	"./donkey-kong.png": "892c",
	"./dragon-quest-xi.png": "a4b7",
	"./duck-hunt.png": "df27",
	"./earthbound.png": "71e7",
	"./f-zero.png": "d2be",
	"./fatal-fury.png": "5715",
	"./final-fantasy.png": "9b5b",
	"./fire-emblem.png": "1736",
	"./game-and-watch.png": "7d50",
	"./ice-climber.png": "f267",
	"./kid-icarus.png": "e2ef",
	"./kingdom-hearts.png": "8fad",
	"./kirby.png": "75fa",
	"./mega-man.png": "8441",
	"./metal-gear-solid.png": "17b7",
	"./metroid.png": "5c59",
	"./mii.png": "1bea",
	"./minecraft.png": "38d1",
	"./pac-man.png": "e0d9",
	"./persona-5.png": "3397",
	"./pikmin.png": "7b37",
	"./pokemon.png": "56c6",
	"./punch-out.png": "8caae",
	"./rob.png": "c3a4",
	"./sonic.png": "5230",
	"./splatoon.png": "e94f",
	"./star-fox.png": "2922",
	"./street-fighter.png": "9bcf",
	"./super-mario-bros.png": "9a9f",
	"./tekken.png": "39c6",
	"./the-legend-of-zelda.png": "1d51",
	"./warioware.png": "ba4c",
	"./wii-fit.png": "d328",
	"./xenoblade-chronicles.png": "28be",
	"./yoshi.png": "77ee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f21f";